import { RootState } from "domain/store";

export const selectCarouselSlides = (state: RootState) => {
  return state.carousel.slides;
};
